import { TReactSetState, TUseTranslationTfn } from "../../data/AppType";
import {
  ADD_CONTACT_DETAILS,
  GET_CONTENT_MANAGEMENT_BY_Id,
  ADD_NEWSLETTER_DETAIL,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  prepareMessageFromParams,
  sweetAlertError,
  sweetAlertSuccess,
  toastError,
} from "../../utils/AppFunctions";
import * as Yup from "yup";

export interface IElement {
  type: string;
  value: string;
}
export interface IContact {
  first_name: string;
  last_name: string;
  contact_email_address: string;
  contact_number?: number;
  message_content: string;
  inquiry_subject: string;
}
export interface INewsletter {
  email: string | undefined;
}
export const contactValidationSchema = (t: TUseTranslationTfn) =>
  Yup.object().shape({
    first_name: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("first_name")],
        ])
      )
      .min(
        2,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("first_name")],
          ["min", "2"],
        ])
      )
      .max(
        50,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("first_name")],
          ["max", "50"],
        ])
      ),
    last_name: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("last_name")],
        ])
      )
      .min(
        2,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("last_name")],
          ["min", "2"],
        ])
      )
      .max(
        50,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("last_name")],
          ["max", "50"],
        ])
      ),
    contact_email_address: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("contact_email_address")],
        ])
      )
      .email(t("error_message_invalid_email"))
      .max(
        75,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("contact_email_address")],
          ["max", "75"],
        ])
      ),
    contact_number: Yup.string()
      .min(
        10,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("contact_number")],
          ["min", "10"],
        ])
      )
      .max(
        15,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("contact_number")],
          ["max", "15"],
        ])
      ),
    inquiry_subject: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("inquiry_subject")],
        ])
      )
      .max(
        200,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("inquiry_subject")],
          ["max", "200"],
        ])
      ),
    message_content: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("message_content")],
        ])
      )
      .max(
        200,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("message_content")],
          ["max", "200"],
        ])
      ),
  });

export const getContactInitialValue = (): IContact => {
  return {
    first_name: "",
    last_name: "",
    contact_email_address: "",
    contact_number: undefined,
    message_content: "",
    inquiry_subject: "",
  };
};
export const handleSubmitContact = async (
  values: IContact,
  setLoading: TReactSetState<boolean>,
  token?: string
) => {
  setLoading(true);
  try {
    let contact;
    contact = await ADD_CONTACT_DETAILS(values, token);
    if (contact && contact.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess(contact.message);
    } else {
      sweetAlertError(contact?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (e: any) {
    sweetAlertError(e?.contact?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
    setLoading(false);
  }
};
export const fetchContactDetails = async (
  setContactUs: TReactSetState<IElement[]>,
  contentType: number
) => {
  try {
    const contentId = await GET_CONTENT_MANAGEMENT_BY_Id(contentType);

    if (contentId && contentId.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setContactUs(contentId.data);
    } else {
      toastError(contentId.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (error: any) {
    toastError(error?.contentId?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
  }
};
export const handleSubmitNewsletter = async (
  values: string,
  setLoading: TReactSetState<boolean>
) => {
  setLoading(true);
  try {
    let contact;
    contact = await ADD_NEWSLETTER_DETAIL(values);
    if (contact && contact.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess(contact.message);
    } else {
      sweetAlertError(contact?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (e: any) {
    sweetAlertError(e?.contact?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
    setLoading(false);
  }
};
